import { postAPI } from 'framework/api/http';
import { useMutation } from 'react-query';

interface GetImageUploadURLInterface {
  fileName: string;
  fileType: string;
}

export const useGetImageUploadURL = () => {
  const mutate = useMutation(({ fileName, fileType }: GetImageUploadURLInterface) => {
    return postAPI('/media-api/image_upload_url', {
      fileName,
      fileType,
    });
  });

  return mutate;
};

export default useGetImageUploadURL;
